export enum ArticleEditMoveSection {
    None,
    SectionOne,
    SectionTwo
}